import twentyFourSeven from '~/assets/icons/247.svg';
import car from '~/assets/icons/car_2.svg';
import job from '~/assets/icons/job_2.svg';
import userRound from '~/assets/icons/user_round.svg';
import { BankTransactionCategory } from '~/shared';
import bank from '../../assets/images/bank_icon.svg';

export const transactionIcons = {
	[BankTransactionCategory.BANK]: bank,
	[BankTransactionCategory.TRANSFER]: userRound,
	[BankTransactionCategory.VEHICLE]: car,
	[BankTransactionCategory.SHOP]: twentyFourSeven,
	[BankTransactionCategory.JOB]: job,
	[BankTransactionCategory.DEPOSIT]: userRound,
	[BankTransactionCategory.WITHDRAW]: userRound,
};

export const transactionText = {
	[BankTransactionCategory.BANK]: 'Оплата налогов',
	[BankTransactionCategory.TRANSFER]: 'Перевод',
	[BankTransactionCategory.VEHICLE]: 'Покупка',
	[BankTransactionCategory.SHOP]: 'Покупка',
	[BankTransactionCategory.JOB]: 'Зарплата',
	[BankTransactionCategory.DEPOSIT]: 'Пополнение',
	[BankTransactionCategory.WITHDRAW]: 'Снятие',
};
